import {
  Box,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { FROST, Pill, Reveal, Section, TEAL_DARK, TEAL_LIGHT } from "./utils";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    quote:
      "A Wobble segítségével könnyedén beállítottam a foglalórendszert, amit amúgy nagyon könnyű kezelni.",
    name: "Réka",
    role: "Magántanár",
    initials: "R",
    bg: "#e8f4f7",
  },
  {
    quote:
      "Az ügyfeleim imádják, hogy éjjel 11-kor is tudnak foglalni. Én meg imádom, hogy nem kell ébren lennem hozzá.",
    name: "Tina",
    role: "Pilates oktató",
    initials: "T",
    bg: "#eef7ee",
  },
];

const SocialProof = () => (
  <Section bg={FROST} id="testimonials">
    <VStack gap={10}>
      <Reveal>
        <VStack gap={3} textAlign="center" maxW="500px" mx="auto">
          <Pill>Elégedett ügyfelek</Pill>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            color={TEAL_DARK}
            letterSpacing="-0.02em"
          >
            Szolgáltatóknak tervezve, róluk szól
          </Heading>
        </VStack>
      </Reveal>

      <SimpleGrid columns={{ base: 1, md: 2 }} gap={5} w="full">
        {testimonials.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <Box
              bg="white"
              borderRadius="2xl"
              p={7}
              border="1px solid"
              borderColor="gray.100"
              boxShadow="sm"
              _hover={{ boxShadow: "md", transform: "translateY(-4px)" }}
              transition="all 0.22s"
              h="full"
            >
              <HStack gap={0.5} mb={4}>
                {[...Array(5)].map((_, i) => (
                  <Icon key={i} as={FaStar} color={TEAL_LIGHT} boxSize={3.5} />
                ))}
              </HStack>
              <Text
                fontSize="sm"
                color="gray.700"
                lineHeight={1.7}
                mb={5}
                fontStyle="italic"
              >
                „{t.quote}"
              </Text>
              <HStack gap={3}>
                <Box
                  w={10}
                  h={10}
                  borderRadius="full"
                  bg={t.bg}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="xs"
                  fontWeight={700}
                  color={TEAL_DARK}
                >
                  {t.initials}
                </Box>
                <Box>
                  <Text fontSize="sm" fontWeight={700} color={TEAL_DARK}>
                    {t.name}
                  </Text>
                  <Text fontSize="xs" color="gray.400">
                    {t.role}
                  </Text>
                </Box>
              </HStack>
            </Box>
          </Reveal>
        ))}
      </SimpleGrid>

      {/* Trust badges */}
      <Reveal>
        <Wrap justify="center" gap={3}>
          {[
            "✅ Nem kérünk kártyaadatokat",
            "🔒 GDPR megfelelő",
            "⚡ 1 óra alatt üzembe helyezhető",
            "🆓 Ingyenes próbaidőszak",
          ].map((b, i) => (
            <WrapItem key={i}>
              <Box
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                borderRadius="full"
                px={4}
                py={1.5}
                fontSize="xs"
                color="gray.500"
                fontWeight={500}
              >
                {b}
              </Box>
            </WrapItem>
          ))}
        </Wrap>
      </Reveal>
    </VStack>
  </Section>
);

export default SocialProof;
